import {Button, Flex} from "antd";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
    faAngleDown, faAngleRight,
    faCode, faFolder,
    faFolderOpen,
    faSquare
} from "@fortawesome/free-solid-svg-icons";
import React from "react";
import {DraftComponent, DraftComponentCategory} from "../../../../../../../../feature/Draft";
import {faFolder as farFaFolder, faFolderOpen as farFaFolderOpen} from "@fortawesome/free-regular-svg-icons";

export const CategoryItem = (
    props: {
        category: DraftComponentCategory,
        active?: boolean,
        fullFilled?: boolean,
        expanded?: boolean,
        embedded?: boolean,
        showEmbeddingState?: boolean,
        children?: React.ReactNode,
        onExpand?: (category: DraftComponentCategory) => void,
        onCategorySelected?: (category: DraftComponentCategory) => void
    }
) => {

    return (
        <Flex
            vertical={true}
            gap={10}
            key={`category-${props.category.category}`}>

            <Button
                type={'dashed'}
                style={{
                    textAlign: 'start',
                    height: "auto",
                    background: props.active ? "#f0f0f0" : undefined,
                    padding: '8px 8px 8px 16px'
                }}
                onDoubleClick={() => {
                    props.onExpand?.(props.category)
                }}
                onClick={() => {
                    props.onCategorySelected?.(props.category)
                }}
            >
                <Flex
                    style={{width: "100%"}}
                    justify={'space-between'}
                    gap={10}
                    align={'center'}>

                    <FontAwesomeIcon
                        style={{color: props.fullFilled == true ? "#0958d9" : props.fullFilled == false ? "#cccccc" : "#faad14"}}
                        fontSize={16}
                        icon={props.expanded ? (props.fullFilled ? faFolderOpen : farFaFolderOpen) : props.fullFilled ? faFolder : farFaFolder}
                    />

                    <div
                        style={{
                            flexGrow: 1,
                            textOverflow: 'ellipsis',
                            overflow: 'hidden'
                        }}
                    >
                        {props.category.title}
                    </div>

                    <Flex gap={10} align={'center'}>
                        <span className="fa-layers fa-fw fa-lg" style={{display: props.showEmbeddingState ? 'block' : 'none'}}>
                            <FontAwesomeIcon
                                icon={faSquare}
                                color={props.embedded == true ? "#17813b" : props.embedded == false ? "#ccc" : "#faad14"}
                            />
                            <FontAwesomeIcon
                                icon={faCode}
                                className={"fa-inverse"}
                                transform="shrink-8"/>
                        </span>
                        <FontAwesomeIcon
                            style={{
                                background: "#ffffff",
                                border: "1px solid #eee",
                                borderRadius: 20,
                                padding: 5,
                                aspectRatio: 1
                            }}
                            icon={props.expanded ? faAngleDown : faAngleRight}
                            onClick={(e) => {
                                props.onExpand?.(props.category)
                                e.stopPropagation()
                            }}/>
                    </Flex>
                </Flex>
            </Button>
            <Flex
                style={{marginLeft: 20}}
                vertical={true}
                gap={10}>
                {props.expanded
                    ? props.category.components.length > 0
                        ? props.children
                        : <Button style={{textAlign: 'start'}} disabled={true} type={'text'}>
                            No components added yet
                        </Button>
                    : ''
                }
            </Flex>
        </Flex>
    )
}